import React from 'react';
import { Card } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import Background from 'components/common/Background';
import invite from 'assets/img/icons/spot-illustrations/49.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Banner = () => (
 <Card className="bg-transparent-50 overflow-hidden">
  <Card.Header className="position-relative">
   <Background
    image={invite}
    className="d-none d-md-block bg-card z-index-1"
    style={{
     backgroundSize: '230px',
     backgroundPosition: 'right bottom',
     zIndex: '-1'
    }}
   />
   <div className="position-relative z-index-2">
    <div>
     <h3 className="text-primary mb-1">Gestion y Configuracion de Empresa!</h3>
     <p className="text-700">Asigne los parámetros necesarios para la configuracion de su empresa</p>
    </div>
    <Flex className="py-3">
     <ul className="fa-ul ms-2 ps-x1 mb-0">
      <li className="py-0">
       <h6 className="text-700">
        <FontAwesomeIcon icon="check" className="fa-li text-success" />
        Valida datos Empresariales
       </h6>
      </li>

      <li className="py-0">
       <h6 className="text-700">
        <FontAwesomeIcon icon="check" className="fa-li text-success" />
        Ajusta tu Privacidad
       </h6>
      </li>

      <li className="py-0">
       <h6 className="text-700">
        <FontAwesomeIcon icon="check" className="fa-li text-success" />
        Perzonaliza y diferenciate
       </h6>
      </li>
     </ul>
    </Flex>
   </div>
  </Card.Header>
 </Card>
);

export default Banner;
